import { CreateMixin, NextFrame } from "@pdfking/reactivity/preact"

let scrollY = 0

const set = (behavior = "", position = "", top = "") => {
  document.documentElement.style.scrollBehavior = behavior
  document.body.style.position = position
  document.body.style.top = top
}

export const FreezeMixin = CreateMixin({
  mounted() {
    scrollY = window.scrollY
    set("none", "fixed", `-${scrollY}px`)
  },
  unmounted() {
    set("auto")
    window.scrollTo(0, scrollY)
    NextFrame(() => set())
  },
})
